/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Server } from './Server';

/**
 * @author eric.wittmann@gmail.com
 * @class
 */
export interface IServerParent {
    /**
     * Creates a server.
     * @return {Server}
     */
    createServer() : Server;

    /**
     * Adds a server.
     * @param {Server} server
     */
    addServer(server : Server);

    /**
     * Gets a server by URL.
     * @param {string} url
     * @return {Server}
     */
    getServer(url : string) : Server;

    /**
     * Gets the list of servers.
     * @return {Server[]}
     */
    getServers() : Array<Server>;
}


